import { Module } from "vuex";

import { RootStateType } from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import { ControllerState } from "./model";

let state: ControllerState = {
  controllers: [],
  controller: {
    id: '',
    name: '',
    description: '',
    createdAt: '',
    status: ''
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<ControllerState, RootStateType>;
